import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Page change hote hi top par scroll karega
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // can also use "smooth"
    });
  }, [pathname]);

  return null;
}
